import { returnZero } from '@ardoq/common-helpers';
import type { GraphItem } from './GraphItem';
import { truncateComponentLabel } from '../truncateText/truncateComponentLabel';
import { getComponentLabelParts } from '../truncateText/getComponentLabelParts';

/** @returns the untruncated graph item label. */
const graphItemLabel = (graphItem: GraphItem) =>
  graphItem.isComponent()
    ? truncateComponentLabel({
        ...getComponentLabelParts(graphItem.modelId),
        measure: returnZero,
        width: Infinity,
      })
    : graphItem.getLabel();

export { graphItemLabel };
